module.exports = __webpack_public_path__ + "static/media/dreamstimeRegister.36a42bfd.png";